import React from 'react';
import BioVitalDetailList from '../bio-vitals/BioVitalDetailList';

// Salt intake detail list (reached from /user-bio-vitals Salt Count drill-down).
const SaltDetailsList = () => (
  <BioVitalDetailList config={{
    title: 'Salt Intake Details',
    routePath: '/salt-details',
    endpoint: '/admin/api/salt-details',
    valueLabel: 'Salt Intake (mg)',
    valueKey: 'salt_intake',
    dateLabel: 'Created At',
    dateKey: 'created_at',
    dateFmt: 'last',
    totalLabel: 'Total Salt Intake',
    breadcrumbType: 'Salt',
    exportName: 'salt-details.csv',
  }} />
);

export default SaltDetailsList;
